import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import Mithril from 'mithril';
import Discussion from 'flarum/common/models/Discussion';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

export interface IStickyDiscussionModalAttrs extends IInternalModalAttrs {
  discussion: Discussion;
  currentTitle: string;
}

/**
 * The 'StickyDiscussionModal' displays a modal dialog with an input to rename a discussion
 */
export default class StickyDiscussionModal<CustomAttrs extends IStickyDiscussionModalAttrs = IStickyDiscussionModalAttrs> extends Modal<CustomAttrs> {
  discussion!: Discussion;
  currentTitle!: string;
  isAllTag!: boolean;
  newTitle!: Stream<string>;
  currentLevel!: string;
  currentIsSticky!: boolean;
  newLevel!: Stream<string>;
  newIsSticky!: Stream<boolean>;
  
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.discussion = this.attrs.discussion;
    this.currentTitle = this.attrs.currentTitle;
    this.isAllTag = this.attrs.isAllTag;
    this.newTitle = Stream(this.currentTitle);
    
    if (this.isAllTag) {
      this.currentIsSticky = this.discussion.isAllSticky();
      this.newIsSticky = Stream(this.discussion.isAllSticky());
      this.currentLevel = this.discussion.allStickyLevel() ? this.discussion.allStickyLevel() : '1';
      this.newLevel = Stream(this.discussion.allStickyLevel() ? this.discussion.allStickyLevel() : '1');
    } else {
      this.currentIsSticky = this.discussion.isSticky();
      this.newIsSticky = Stream(this.discussion.isSticky());
      this.currentLevel = this.discussion.stickyLevel() ? this.discussion.stickyLevel() : '1';
      this.newLevel = Stream(this.discussion.stickyLevel() ? this.discussion.stickyLevel() : '1');
    }
    
  }

  className() {
    return 'RenameDiscussionModal Modal--small';
  }

  title() {
    return app.translator.trans('flarum-sticky.forum.discussion_controls.sticky_button') + this.currentTitle;
  }

  handleCheckboxChange = () => {
    this.newIsSticky = !this.newIsSticky;
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <label className="checkbox">
              <input type="checkbox" bidi={this.newIsSticky} />
              {app.translator.trans('flarum-sticky.forum.discussion_controls.issticky_button')}
            </label>
          </div>
          {this.newIsSticky() && (
            <div className="Form-group">
              <label>{app.translator.trans('flarum-sticky.forum.discussion_controls.top_priority')}:</label>
              <input className="FormControl" bidi={this.newLevel} type="number" />
            </div>
            )
          }
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
              {app.translator.trans('flarum-sticky.forum.discussion_controls.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e: SubmitEvent): Promise<void> | void {
    e.preventDefault();

    this.loading = true;

    const newIsSticky = this.newIsSticky();
    const currentIsSticky = this.currentIsSticky;
    let newLevel = this.newLevel();
    const currentLevel = this.currentLevel;

    // If the title is different to what it was before, then save it. After the
    // save has completed, update the post stream as there will be a new post
    // indicating that the discussion was renamed.
    if ((newIsSticky !== currentIsSticky) || (newLevel && newLevel !== currentLevel)) {
      if (!newIsSticky) {
        newLevel = ''
      }
      let obj = { isSticky: newIsSticky, stickyLevel: newLevel};
      if (this.isAllTag) {
        obj = { isAllSticky: newIsSticky, allStickyLevel: newLevel};
      }
      return this.discussion.save(obj)
      .then(() => {
        // if (app.viewingDiscussion(this.discussion)) {
        //   app.current.get('stream').update();
        // }
        AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!newIsSticky ? 'not_push_label' : 'push_label'}`))
        app.discussions.refresh();
        m.redraw();
        app.modal.close()
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
    } else { 
      app.modal.close()
    }
  }
}
